<script>
export default {
	setup() {
		return {
			freelance: [
        {
					img: 'https://nqa-indonesia.com/wp-content/uploads/2023/02/logo_nqa_web-removebg-preview.png',
					company: 'NQA Indonesia',
					job: 'Quality Assurance Trainer',
					date: 'August 2026',
				},
				{
					img: 'https://www.globaledu.co.id/themes/default/images/frontend/web/logo.png',
					company: 'GlobalEdu',
					job: 'Quality Assurance Trainer', 
					date: 'February - October 2026',
				},
			],
		}
	},
};
</script>

<template>
  <div>
    <!-- Experience -->
    <div class="py-10">
      <p class="text-left w-full font-general-bold text-3xl text-secondary-dark dark:text-secondary-light mb-5">
        Freelance/Training Workshop
      </p>
      <section
        v-for="(course, index) in freelance"
        :key="index"
      >
        <div class="flex flex-row mb-2">
          <div>
            <img
              :src="course.img"
              class="h-12 object-contain bg-white w-12 rounded-xl"
            >
          </div>	
          <div>
            <h2 class="text-start font-general-bold text-2xl text-secondary-dark dark:text-secondary-light mb-2 pt-2 pl-4">
              {{ course.company }}
            </h2>
          </div>
        </div>	
        <div class="w-full mb-7 sm:mb-0">
          <div class="w-full mb-7 sm:mb-0">
            <div class="mb-7">
              <p class="text-left font-general-medium text-xl text-ternary-dark dark:text-ternary-light mb-2">
                {{ course.job }}
              </p>
              <p class="text-left font-general-regular text-md text-primary-dark dark:text-ternary-light">
                {{ course.date }}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
